import { SaleChannelPlatformTypes } from './i-platform-type.model';
import { SaleChannelTypes } from './i-channel-type.model';

export interface IInsertSaleChannel {
  name: string;
  channel: SaleChannelTypes;
  description: string;
  platformType: SaleChannelPlatformTypes
}
